import React, { useState, useCallback, useEffect } from 'react';
import Grid from "@mui/material/Grid";
import AppBarTitle from "../typography/AppBarTitle";
import { useTranslation } from "react-i18next";
import Table from "./table/Table/Table";
import { useDispatch, useSelector } from 'react-redux';
import { fetchSupport, fetchTickets, selectTicket } from "../../../store/actions/SupportAction";
import { matchPath, useHistory, useLocation, Routes, Route } from '../../utils/reactRouterCompatibility';
import Ticket from "./Ticket";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from '@mui/material/styles';
import Loading from "../feeback/loading/Loading";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Filters from "./Filters";
import Collapse from "@mui/material/Collapse";
import SelectRealm from "../../../pages/SelectRealm";
import Toolbar from "../typography/Toolbar";
import { getSupportBoxRoute, getSupportBoxTicketRoute } from "../../../router/routes/support/factory/boxes";

const TableColumn = styled(Grid)(({ theme }) => ({
    borderRight: `1px solid ${theme.palette.divider}`,
}));

const MailBox = ({ box, disabled }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));
    const [filtersShown, setFiltersShown] = useState(false);

    const tags = useSelector(state => state.support.supportClassifyTags);
    const tagsLoading = useSelector(state => state.support.supportClassifyTagsLoading);
    const selectedRealm = useSelector(state => state.realm.selected);

    const hasTicket = matchPath(getSupportBoxTicketRoute(box), location.pathname) !== null;

    const refreshTickets = useCallback(() => dispatch(fetchTickets(true)), [dispatch]);
    const refreshSupport = useCallback((id) => dispatch(fetchSupport(id, true)), [dispatch]);
    const resetSelectedTicket = useCallback(() => dispatch(selectTicket(null)), [dispatch]);

    useEffect(() => {
        if (!hasTicket) {
            resetSelectedTicket();
        }
    }, [hasTicket, resetSelectedTicket]);

    if (!selectedRealm && !hasTicket) return <SelectRealm />;

    const handleClose = (d) => {
        refreshTickets();
        refreshSupport(d.Support__);
        resetSelectedTicket();
        history.push(getSupportBoxRoute(box));
    };

    const handleReplied = (d) => {
        refreshTickets();
        refreshSupport(d.Support__);
        resetSelectedTicket();
        history.push(getSupportBoxRoute(box));
    };

    return (
        <Grid container spacing={3}>
            <AppBarTitle title={t('support_' + box + '_title')} />
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Toolbar title={t('support_' + box + '_title')}>
                            {tagsLoading && <Loading />}
                            {(!tagsLoading && tags.length > 0) && (
                                <Tooltip title={t('filters')}>
                                    <IconButton
                                        aria-label={t('filters')}
                                        onClick={() => setFiltersShown(!filtersShown)}
                                        size="large"
                                    >
                                        {!filtersShown ? <FilterListIcon /> : <ExpandLessIcon />}
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Toolbar>
                        <Collapse in={filtersShown}>
                            <Toolbar>
                                <Filters />
                            </Toolbar>
                        </Collapse>
                    </Grid>

                    {hasTicket && !mobile ? (
                        <TableColumn item xs={5}>
                            <Table disabled={disabled} box={box} />
                        </TableColumn>
                    ) : !hasTicket ? (
                        <Grid item xs={12}>
                            <Table disabled={disabled} box={box} />
                        </Grid>
                    ) : null}

                    {hasTicket && (
                        <Grid item xs={mobile ? 12 : 7}>
                            <Routes>
                                <Route
                                    path=":ticketId"
                                    element={
                                        <Ticket
                                            onReplied={handleReplied}
                                            onClosed={handleClose}
                                            box={box}
                                        />
                                    }
                                />
                            </Routes>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default MailBox;